import { truncateNameWithDot, uppercaseFirstCharInText } from '@sky-it-livedata-libraries/livedata-commons';
import { IDriverInfoTotalPoints } from '../types/driver';
import { IDriverSessionDetail } from '../types/session';

export const getDriverName = (row: IDriverInfoTotalPoints | IDriverSessionDetail): string =>
    row.customDriverName && row.customDriverSurname
      ? `${row.customDriverSurname} ${truncateNameWithDot(row.customDriverName)}`
      : `${uppercaseFirstCharInText(row.lastName)} ${truncateNameWithDot(row.firstName.toUpperCase())}`;